import React, { useState, useEffect } from 'react'
import { Layout, Spin } from 'antd'
import styled from 'styled-components'
import { MainMenu } from '../layouts/components/MainMenu'
import { DBVisor } from '../layouts/components/DBVisor'
import { MapContainer } from '../layouts/components/MapContainer'
import { GeneralContainer } from '../layouts/components/GeneralContainer'
import { MapMetric } from '../services/map-metrics.service'
import { MapAutonomousCommunity, MapMunicipality, MapProvince } from '../services/map-municipalities.service'
import { MapLayout } from '../layouts/MapLayout'
import { MapHelper } from '../components/MapHelper'
import { SPAIN } from './map-page.util'

export { SPAIN }

const initialMetric: MapMetric = { "id": 1, "name": "Factura energética doméstica total", "unit": "€/hogar equivalente·año", "periodicity": "Anual", "sources": [], "range": [344.83085110592, 1782.5860246416] };
const initialAutonomousCommunity: MapAutonomousCommunity = SPAIN;

export const MapPage: React.FC = () => {

  const [selectedMetric, setSelectedMetric] = useState<MapMetric>(initialMetric);
  const [selectedMunicipalities, setSelectedMunicipalities] = useState<MapMunicipality[]>([])
  const [selectedProvinces, setSelectedProvinces] = useState<MapProvince[]>([])
  const [selectedAutonomousCommunities, setSelectedAutonomousCommunities] = useState<MapAutonomousCommunity[]>([])

  const setMapContent = (
    { metric, municipalities, provinces, autonomousCommunities }:
      { metric: MapMetric, municipalities: MapMunicipality[], provinces: MapProvince[], autonomousCommunities: MapAutonomousCommunity[] }) => {
    setSelectedMetric(metric)
    setSelectedMunicipalities(municipalities)
    setSelectedProvinces(provinces)
    setSelectedAutonomousCommunities(autonomousCommunities)
  }

  return (
    <CustomLayout>
      <MainMenu />
      <DBVisor pageTitle="Atlas" />
      <MapLayout title=''>
        <MapContainer
          setMapContent={setMapContent}
          autonomousCommunities={selectedAutonomousCommunities}
          metric={selectedMetric}
        >
          <GeneralContainer>
            <MapHelper
              autonomousCommunities={selectedAutonomousCommunities}
              provinces={selectedProvinces}
              municipalities={selectedMunicipalities}
              metric={selectedMetric!}
            />
          </GeneralContainer>
        </MapContainer>
      </MapLayout>
    </CustomLayout>
  )
}

const CustomLayout = styled(Layout)`
  /* el visor ya reserva la altura de la cabecera: sin padding extra arriba */
  padding-top: 0;
  background-color: #fff;
`